module.exports = __webpack_public_path__ + "img/马国锐教授.bfa63c8e.png";